import { gql } from '@apollo/client';

import client from '../../../core/services/graphql';

export const createCompanyMutation = async (userId, companyName) => {
  const query = gql`
    mutation CreateCompanyMutation($userId: ID!, $companyName: String!) {
      createCompany(userId: $userId, companyName: $companyName) {
        company {
          id
          balanceRemaining
          name
          plan
          balanceUsed
          stripeCustomerId
          inviteLink
          inviteToggleUserId
          consentFormRequired
        }
      }
    }
  `;

  const { data } = await client.getClient().mutate({
    mutation: query,
    variables: { userId, companyName },
  });

  return data;
};
